import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import React from "react";
import { TextArea } from "react-vcomponents";
import { ScrollView } from "react-vscrollview";
import { E } from "js-vextensions";
import { HandleError } from "../General/Errors.js";
export function BuildErrorWrapperComp(regularUIFunc_getter, errorUI, errorUIStyle) {
    return class ErrorWrapperComp extends BaseComponent {
        componentDidCatch(message, info) { EB_StoreError(this, message, info); }
        ClearError() { this.SetState({ error: null }); }
        render() {
            const { error } = this.state;
            if (error) {
                const errorUIProps = { error, style: errorUIStyle, defaultUI: defaultErrorUI };
                return (errorUI !== null && errorUI !== void 0 ? errorUI : defaultErrorUI)(errorUIProps, this);
            }
            const RegularUIFunc = regularUIFunc_getter();
            return React.createElement(RegularUIFunc, { ...this.props });
        }
    };
}
export const defaultErrorUI = (props) => {
    const { error, style } = props;
    return (React.createElement(ScrollView, { style: E({ height: "100%", maxHeight: "100px" }, style) },
        React.createElement(TextArea, { autoSize: true, value: `An error has occurred in the UI-rendering code.\n\n${error.message}\n${error.info.componentStack}` })));
};
// todo: maybe remove this; better to just use componentDidError + "EB_" functions below directly
export class ErrorBoundary extends BaseComponentPlus({}, { error: null }) {
    componentDidCatch(message, info) { EB_StoreError(this, message, info); }
    ClearError() { this.SetState({ error: null }); }
    render() {
        const { errorUI, errorUIStyle, children } = this.props;
        const { error } = this.state;
        if (error) {
            const errorUIProps = { error, style: errorUIStyle, defaultUI: defaultErrorUI };
            return (errorUI !== null && errorUI !== void 0 ? errorUI : defaultErrorUI)(errorUIProps, this);
        }
        return children;
    }
}
// function-based approach
// todo: maybe add this functionality to the BaseComponentPlus function/class
export function EB_StoreError(comp, error, errorInfo) {
    const errorMessage = typeof error == "object" ? error.message : error;
    if (errorMessage.startsWith("[generic bail error")) {
        //throw new Error(`A bail-error was caught by react (${comp.constructor.name}.componentDidCatch); this should not occur. Did you forget to add "@Observer" to your component class?`);
        HandleError(new Error(`A bail-error was caught by react (${comp.constructor.name}.componentDidCatch); this should not occur. Did you forget to add "@Observer" to your component class?`));
    }
    const error_final = { message: errorMessage, origError: error, info: errorInfo };
    comp.SetState({ error: error_final });
    console.log(`%c In ErrorBoundary/componentDidCatch. error:`, "color: #222; background: #dfd");
    console.log(error_final);
    //logErrorToMyService(error, info);
}
export function EB_ShowError(error, style) {
    return defaultErrorUI({ error, style, defaultUI: defaultErrorUI });
}
//# sourceMappingURL=ErrorBoundary.js.map